import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { util } from '../../../classes/util';
import { environment } from '../../../environment';
import { ESRI } from '../../../esri-loader-util';
import { LineStyleOptions } from '../../../selectionOptions';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
var initilizeDebounceTime = 50;
var Draw;
var Graphic;
var GeometryService;
var LengthsParameters;
var DrawLineComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DrawLineComponent, _super);
    function DrawLineComponent(_vcr, cdr, layerService) {
        var _this = _super.call(this, _vcr) || this;
        _this.cdr = cdr;
        _this.layerService = layerService;
        _this.drawComplete = new EventEmitter();
        _this.drawLayer = new EventEmitter();
        _this.createLayerForEachGraphic = true;
        _this.showSettings = {
            createLayerForEachGraphic: true,
            mode: true,
            style: true,
            width: true,
            color: true,
            unit: true
        };
        _this.defaultSymbolProperties = {
            type: 'simple-line',
            style: 'solid',
            color: 'red',
            width: 3,
            cap: 'round',
            join: 'round'
        };
        _this.lineStyleOptions = LineStyleOptions;
        _this.polylineModes = [
            { value: 'click', name: 'Click', description: 'Vertices are added when the pointer is clicked.' },
            { value: 'freehand', name: 'Freehand', description: 'Vertices are added while the pointer is dragged.' },
            { value: 'hybrid', name: 'Hybrid', description: 'Vertices are added while the pointer is clicked or dragged.' }
        ];
        _this.selectedPolylineMode = _this.polylineModes[0];
        _this.lengthUnits = [
            { name: 'None', value: null },
            { name: 'Inches', value: 109009, description: 'US Inch' },
            { name: 'Feet', value: 9300, description: 'US Feet' },
            { name: 'Yards', value: 109002, description: 'US Yard' },
            { name: 'Miles', value: 9035, description: 'US Mile' },
            { name: 'Centimeters', value: 109006 },
            { name: 'Meters', value: 9001 },
            { name: 'Kilometers', value: 9036 }
        ];
        _this.selectedLengthUnit = _this.lengthUnits[0];
        _this.initializing = false;
        _this.listners = [];
        return _this;
    }
    Object.defineProperty(DrawLineComponent.prototype, "enabled", {
        set: function (enabled) {
            this._enabled = enabled;
            if (this._enabled) {
                this.setupHandleHiddenLayer();
                this.createPolylineDrawAction();
            }
            else {
                this.draw.reset();
                this.teardownHandleHiddenLayer();
                if (this.graphic) {
                    this.mapView.graphics.remove(this.graphic);
                }
                this.cdr.detectChanges();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DrawLineComponent.prototype, "colorPickerRef", {
        set: function (el) { this.colorPicker = el; },
        enumerable: true,
        configurable: true
    });
    DrawLineComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, err_1;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, 4, 5]);
                        this.symbolProperties = this.defaultSymbolProperties;
                        _b = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 1:
                        _b.mapView = _c.sent();
                        return [4 /*yield*/, Promise.all([ESRI.Draw, ESRI.Graphic, ESRI.GeometryService, ESRI.LengthsParameters])];
                    case 2:
                        _a = tslib_1.__read.apply(void 0, [_c.sent(), 4]), Draw = _a[0], Graphic = _a[1], GeometryService = _a[2], LengthsParameters = _a[3];
                        this.draw = new Draw({ view: this.mapView });
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _c.sent();
                        this.readyProblem(err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isReady();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    DrawLineComponent.prototype.createPolylineDrawAction = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var action;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                action = this.draw.create('polyline', { mode: this.selectedPolylineMode.value });
                action.on(['vertex-add', 'vertex-remove', 'cursor-update'], function (evt) {
                    _this.graphic = _this.createPolylineGraphic(evt.vertices);
                    _this.mapView.graphics.add(_this.graphic);
                });
                action.on('draw-complete', function (evt) {
                    var completedGraphic = _this.createPolylineGraphic(evt.vertices);
                    _this.addLineGraphic(completedGraphic);
                    _this.drawComplete.emit(completedGraphic);
                    _this.createPolylineDrawAction();
                });
                return [2 /*return*/];
            });
        });
    };
    DrawLineComponent.prototype.createPolylineGraphic = function (vertices) {
        if (vertices.length > 1 && this.graphic) {
            this.mapView.graphics.remove(this.graphic);
        }
        var polyline = {
            type: 'polyline',
            paths: vertices,
            spatialReference: this.mapView.spatialReference
        };
        var graphic = new Graphic({
            geometry: polyline,
            symbol: this.symbolProperties
        });
        return graphic;
    };
    DrawLineComponent.prototype.addLineGraphic = function (graphic) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var title, result, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!this.graphicsLayer || this.createLayerForEachGraphic)) return [3 /*break*/, 4];
                        title = 'Line';
                        if (this.selectedPolylineMode.value === 'freehand') {
                            title = this.selectedPolylineMode.name + " " + title;
                        }
                        if (!this.selectedLengthUnit.value) return [3 /*break*/, 2];
                        this.isLoading = true;
                        if (!this.geometryService) {
                            this.geometryService = new GeometryService({ url: environment.geometryServiceUrl });
                        }
                        return [4 /*yield*/, this.geometryService.lengths(new LengthsParameters({
                                calculationType: 'preserve-shape',
                                lengthUnit: this.selectedLengthUnit.value,
                                polylines: [graphic.geometry]
                            }))];
                    case 1:
                        result = _b.sent();
                        if (result && result.lengths.length) {
                            title += " - " + result.lengths[0] + " " + this.selectedLengthUnit.name;
                        }
                        this.isLoading = false;
                        this.cdr.detectChanges();
                        _b.label = 2;
                    case 2:
                        _a = this;
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: title, graphicLayer: 'line' })];
                    case 3:
                        _a.graphicsLayer = _b.sent();
                        _b.label = 4;
                    case 4:
                        this.graphicsLayer.add(graphic);
                        this.drawLayer.emit(this.graphicsLayer);
                        this.graphic = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    DrawLineComponent.prototype.reset = function () {
        this.draw.reset();
        this.createPolylineDrawAction();
    };
    DrawLineComponent.prototype.setupHandleHiddenLayer = function () {
        var _this = this;
        this.initializing = true;
        var stopInitialCheck = util.debounce(function () { _this.initializing = false; }, initilizeDebounceTime);
        this.listners.push(this.layerService.mapRef.allLayers.on('before-add', function (event) {
            if (_this.initializing && event.item.listMode === 'hide') {
                event.item.set('hideInLegend', true);
                event.item.set('drawLineToolGeneratedLayer', true);
                stopInitialCheck();
            }
        }));
        this.listners.push(this.layerService.mapRef.allLayers.on('after-remove', function (event) {
            if (event.item.get('drawLineToolGeneratedLayer')) {
                _this.initializing = true;
            }
        }));
    };
    DrawLineComponent.prototype.teardownHandleHiddenLayer = function () {
        while (this.listners.length) {
            this.listners.pop().remove();
        }
    };
    return DrawLineComponent;
}(BaseComponent));
export { DrawLineComponent };
